import React from 'react'
import PropTypes from 'prop-types'
import Button from '../Button'
import './plan.css'

function Plan({ id, recurs, title, subTitle, price, priceYearly, features, selected, onSelect }) {

    const current = selected === title ? true : false

    function handleSelect() {
        if (onSelect) {
            onSelect(id)
        }
    }

    return(
        <div className='plan__container'>
            <div className='plan__title'>{ title }<div className='plan__subTitle'>{ subTitle }</div></div>
            <div className='plan__price'>${ recurs === 'annually' ? priceYearly : price }</div>
            <div className='plan__per'>/month</div>
            <Button large fullWidth onClick={ handleSelect } disabled={current}>{ current ? 'Your current plan' : 'Select this plan' }</Button>
            <div className='plan__features'>
                {
                    features.map((feature, i) => (
                        <div className='plan__feature' key={i}>
                            <i className='material-icons'>check</i>
                            { feature }
                        </div>
                    ))
                }
            </div>
        </div>
    )

}

Plan.propTypes = {
    recurs: PropTypes.string,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    price: PropTypes.string.isRequired,
    priceYearly: PropTypes.string,
    features: PropTypes.array.isRequired
}

class Plans extends React.Component {

    render() {

        const { children, selected } = this.props
        // const { recurs } = this.state

        const childrenWithProps = React.Children.map(children, child => {
            return React.cloneElement(child, { selected })
        })

        return <React.Fragment>
            {/* <button onClick={() => { this.setState({ recurs: this.state.recurs === 'monthly' ? 'yearly' : 'monthly' }) }}>{ this.state.recurs }</button> */}
            <div className='pricing__container'>{childrenWithProps}</div>
        </React.Fragment>

    }

}

export {
    Plans,
    Plan
}


// WEBPACK FOOTER //
// ./src/components/Plan/index.js